import { Tabs, TabsContent } from "@/components/tabs";
import type { ActionNode } from "@repo/shared/workflow";
import type React from "react";
import { Console as ConsoleExport, RHS as RHS_EXPORT } from "./Export";
// import {
//   Console as ConsoleREST,
//   HistoryRow as RESTHistoryRow,
// } from "./REST/Runner";
import { Console as ConsoleRPA, RHS as RHS_RPA } from "./RPA/Runner";

type Props = {
  actionNode: ActionNode;
  taskId: string;
  runId: string;
};

export const Console: React.FC<Props> = ({
  actionNode: action,
  taskId,
  runId,
}) => {
  return (
    <div
      // Pass key to refresh immediately when action changes
      key={action.id}
    >
      {/* {action.subType === "rest" && (
        <ConsoleREST actionNode={action} taskId={taskId} runId={runId} />
      )} */}
      {action.subType === "rpa" && (
        <ConsoleRPA actionNode={action} taskId={taskId} runId={runId} />
      )}
      {action.subType === "export" && (
        <ConsoleExport actionNode={action} taskId={taskId} runId={runId} />
      )}
    </div>
  );
};

export const RHS: React.FC<Props> = ({ actionNode: action, taskId, runId }) => {
  return (
    <div className="w-4/5 rounded overflow-auto px-2 pb-2 bg-white flex flex-col h-full">
      {/* <h3 className="font-bold text-lg mt-4 mb-2">Actions</h3> */}
      <Tabs defaultValue="run" className="mt-4 mb-2">
        <TabsContent value="run">
          <div className="flex-1">
            {/* {action.subType === "rest" && (
              <RHS_REST
                workflowId={workflowId}
                actionNode={action}
                taskId={taskId}
              />
            )}*/}
            {action.subType === "rpa" && (
              <RHS_RPA taskId={taskId} runId={runId} actionNode={action} />
            )}
            {action.subType === "export" && (
              <RHS_EXPORT runId={runId} actionNode={action} taskId={taskId} />
            )}
          </div>
        </TabsContent>
        {/* <TabsContent value="history">
          <History actionNode={action} />
        </TabsContent> */}
      </Tabs>
      <div className="w-full border-b h-px my-2" />
    </div>
  );
};
